import AssertionEntity from '../../lib/FormValidator/Assertion/AssertionEntity';
import AssertionItem from '../../lib/FormValidator/Assertion/AssertionItem';
import { PlanillaPartidoJugador } from '../PlanillaPartidoJugador/PlanillaPartidoJugador';
import { PlanillaPartido } from './PlanillaPartido';
export class PlanillaDigitalAssertions extends AssertionEntity {
  private constructor() {
    super();
  }

  static build() {
    const instance = new this();
    return instance;
  }
}
